import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;

  > span {
    color: #494949;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;

  > textarea {
    resize: none;
    padding: 0.5rem;
  }
`

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  background-color: #f5f5f5;
  align-self: flex-end;
`
